// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1Vh6x","inputWrap":"styles_inputWrap__BG-JP","input":"styles_input__1qs7r"};